// Small component to wrap the useHandleOnLoadTriggers hook. To stop it deopting serverside code.

import useHandleOnLoadTriggers from "~/hooks/useHandleOnLoadTriggers";

const LoadTriggerWrap = () => {
  useHandleOnLoadTriggers();

  return null;
};

export default LoadTriggerWrap;
